export default "__VITE_ASSET__CAR48Zl2__"